import React from "react";
import { Skeleton, Button, Grid } from "@mui/material";

export function DefaultAmountOptionsSkeleton() {
    return <Grid container className="AmountOptions">
        {[...Array(4)].map((value, index) => {
            return <Grid key={index} item xs={3}>
                <Button
                    id="customAmount"
                    name="donationAmount"
                    variant='outlined'
                    sx={{
                        borderColor: '#C8C8C8',
                        color: '#495057',
                    }}
                    fullWidth
                    disabled
                >
                    <Skeleton width={40} />
                </Button>
            </Grid>
        })}
    </Grid>
}